// Metric Card Component
// Displays a single metric with comparison to previous period

import { Card, CardContent } from '@/components/ui/card';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';

const MetricCard = ({ title, value, previousValue, change, suffix = '', icon: Icon }) => {
  const isPositive = change >= 0;
  
  return (
    <Card className="border-slate-200">
      <CardContent className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-slate-500 mb-1">{title}</p>
            <p className="text-3xl font-bold text-slate-900">
              {value}{suffix}
            </p>
            <div className="flex items-center gap-1 mt-2">
              {isPositive ? (
                <ArrowUpRight className="w-4 h-4 text-emerald-500" />
              ) : (
                <ArrowDownRight className="w-4 h-4 text-red-500" />
              )}
              <span className={`text-sm font-medium ${isPositive ? 'text-emerald-600' : 'text-red-600'}`}>
                {isPositive ? '+' : ''}{change}{suffix === '%' ? 'pp' : '%'}
              </span>
              <span className="text-xs text-slate-400">vs prev period</span>
            </div>
          </div>
          <div className="w-12 h-12 bg-teal-50 rounded-xl flex items-center justify-center">
            <Icon className="w-6 h-6 text-teal-600" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default MetricCard;
